module.exports = __webpack_public_path__ + "img/tv.d898c5b.svg";